import {
  ChangeDetectorRef,
  Component,
  inject,
  output,
  OutputEmitterRef,
} from '@angular/core';
import {
  MatCard,
  MatCardContent,
  MatCardHeader,
  MatCardImage,
} from '@angular/material/card';
import { MatButton } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';
import { NgOptimizedImage, NgStyle } from '@angular/common';
import { MatRadioButton, MatRadioGroup } from '@angular/material/radio';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-animated-tooltip',
  imports: [
    MatButton,
    MatCard,
    MatCardContent,
    MatCardHeader,
    MatCardImage,
    MatRadioButton,
    MatRadioGroup,
    NgOptimizedImage,
    NgStyle,
    FormsModule,
    TranslateModule,
  ],
  templateUrl: './animated-tooltip.component.html',
  styleUrl: './animated-tooltip.component.scss',
})
export class AnimatedTooltipComponent {
  stepChange: OutputEmitterRef<number> = output<number>();
  step = 1;
  authenticators = ['Microsoft', 'Google'];
  authenticator: 'Google' | 'Microsoft' = 'Microsoft';

  private cdr = inject(ChangeDetectorRef);

  goToStep(step: number) {
    this.step = step;
    this.stepChange.emit(step);
    this.cdr.detectChanges();
  }
}
